
import MedicinesTable from 'components/Medicines';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const Medicines = () => {
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );
  const isMedicinesPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'Medicines',
    permission: ['view','viewAll'],
  });
  return <div>{isMedicinesPermission && <MedicinesTable />}</div>;
};
